import { defineRecipe } from "@chakra-ui/react"

const recipes = {
    heading: defineRecipe({
        base: {
            fontWeight: 600,
            fontFamily: "heading",
        },
        variants: {
            size: {
                "4xl": {
                    fontSize: "4xl",
                    lineHeight: "1.2",
                },
            },
        },
        compoundVariants: [
            {
                as: "h1",
                css: {
                    fontSize: "4xl",
                    lineHeight: "1.2",
                },
            },
        ],
        defaultVariants: {
            size: "4xl",
        },
    }),
    container: defineRecipe({
        base: {
            padding: 0,
        },
    }),
    drawer: defineRecipe({
        variants: {
            size: {
                special: {
                    maxW: "46rem",
                },
            },
        },
    }),
    button: defineRecipe({
        base: {
            fontWeight: 600,
            _focus: {
                boxShadow: "none",
            },
        },
        variants: {
            size: {
                md: {
                    textStyle: "md",
                },
            },
        },
    }),
}

export default recipes
